import { render, staticRenderFns } from "./UiDataGridSection.vue?vue&type=template&id=68ba805c&"
import script from "./UiDataGridSection.vue?vue&type=script&lang=js&"
export * from "./UiDataGridSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports